import React, { useContext, useEffect, useState } from "react";
import {
  IonAlert,
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import useAPI from "../../hooks/basic/useAPI";
import ParticipantList from "../../components/ParticipantList/ParticipantList";
import AthletesModal from "../../components/AthletesModal/AthletesModal";
import { ClubsContext } from "../../providers/ClubsProvider/ClubsProvider";
import { AuthenticationContext } from "../../providers/AuthenticationProvider/AuthenticationProvider";
import { useHistory } from "react-router";

const MatchSettingsPage = ({ match }) => {
  const matchId = match.params.matchId;

  const history = useHistory();
  const { coaches } = useContext(ClubsContext);
  const { appUserId, isCoach } = useContext(AuthenticationContext);
  console.log("Match settings page aaaaaa:", matchId, appUserId, isCoach, coaches);
  const { callAPI } = useAPI();
  const [matchData, setMatch] = useState(null);
  const [athletes, setAthletes] = useState([]);
  const [managers, setManagers] = useState([]);
  const [isPublic, setIsPublic] = useState(false);
  const [viewers, setViewers] = useState([]);
  const [openManagersModal, setOpenManagersModal] = useState(false);
  const [openViewersModal, setOpenViewersModal] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);

  const loadAllAthletes = async () => {
    const coachesIds = coaches.map((coach) => coach.id);

    const allAthletes = await callAPI({
      url: "/athletes-by-coaches",
      params: {
        coachesIds: coachesIds.join(","),
      },
    });
    return allAthletes;
  };

  const populateAthletesByCoach = async () => {
    const allAthletes = await callAPI({
      url: "/athletes-by-coach",
      params: {
        coachId: appUserId,
      },
      preventCall: !appUserId,
    });

    return allAthletes;
  };

  const deleteMatch = async () => {
    try {
      await callAPI({
        url: `/match`,
        method: "DELETE",
        data: {
          id: matchId,
        },
      });
      // go back to the previous page
      history.replace(`/match-list`);
    } catch (error) {
      console.error(error);
    }
  };

  const loadMatch = async () => {
    try {
      const response = await callAPI({
        url: `/match`,
        params: {
          id: matchId,
        },
      });

      const retrieveAthletesFunc = isCoach
        ? populateAthletesByCoach
        : loadAllAthletes;
      const allAthletes = await retrieveAthletesFunc();

      // sort athletes by cognome then nome
      allAthletes.sort((a, b) => {
        const nameA = a.cognome.toLowerCase();
        const nameB = b.cognome.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      setAthletes(allAthletes);
      setMatch(response);
      setIsPublic(response.public);
      const athletesAsManagers = allAthletes.filter((athlete) =>
        (response?.managers ?? []).find(
          (manager) => manager === athlete.userId,
        ),
      );
      const athletesAsViewers = allAthletes.filter((athlete) =>
        (response?.viewers ?? []).find((viewer) => {
          return viewer === athlete.userId;
        }),
      );
      setManagers(athletesAsManagers);
      setViewers(athletesAsViewers);
    } catch (error) {
      console.error(error);
    }
  };

  const updateMatch = async () => {
    try {
      await callAPI({
        url: `/update-match-settings`,
        method: "POST",
        data: {
          matchId,
          isPublic,
          managers: managers.map((manager) => manager.userId),
          viewers: viewers.map((viewer) => viewer.userId),
        },
      });
      // go back to the previous page
      // history.push(`/match/${matchId}`);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("Match settings page mounted aaaaaa:", matchId, appUserId);
    if (appUserId) {
      loadMatch();
    }
  }, [appUserId, coaches, matchId]);

  if (!matchData) {
    return null;
  }

  return (
    <IonPage>
      <IonContent id="match-page">
        <IonList>
          <IonItem>
            <IonSelect
              label="Condivisione"
              onIonChange={(e) => {
                setIsPublic(e.detail.value === "public");
              }}
              value={isPublic ? "public" : "private"}
            >
              <IonSelectOption value="public">Pubblico</IonSelectOption>
              <IonSelectOption value="private">Privato</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem onClick={() => setOpenManagersModal(true)}>
            <IonLabel>Gestori</IonLabel>
            <ParticipantList
              participants={managers}
              onRemoveClick={(e, currentManager) => {
                e.preventDefault();
                setManagers(
                  managers.filter(
                    (manager) => manager.userId !== currentManager.userId,
                  ),
                );
              }}
            />
          </IonItem>
          <IonItem onClick={() => setOpenViewersModal(true)}>
            <IonLabel>Spettatori</IonLabel>
            <ParticipantList
              participants={viewers}
              onRemoveClick={(e, currentViewer) => {
                e.preventDefault();
                setViewers(
                  viewers.filter(
                    (viewer) => viewer.userId !== currentViewer.userId,
                  ),
                );
              }}
            />
          </IonItem>
        </IonList>
      </IonContent>
      <AthletesModal
        isOpen={openManagersModal}
        athletes={athletes}
        selectedAthletes={managers}
        onConfirm={(managers) => {
          setManagers(managers);
          setOpenManagersModal(false);
        }}
        onDismiss={() => setOpenManagersModal(false)}
      />
      <AthletesModal
        isOpen={openViewersModal}
        athletes={athletes}
        selectedAthletes={viewers}
        onConfirm={(viewers) => {
          setViewers(viewers);
          setOpenViewersModal(false);
        }}
        onDismiss={() => setOpenViewersModal(false)}
      />
      <IonFooter
        className="ion-no-border ion-padding"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: ".5rem",
        }}
      >
        <div>
          <IonButton
            color="danger"
            expand="block"
            size="large"
            onClick={() => setShowDeleteAlert(true)}
          >
            Cancella Partita
          </IonButton>
          <IonAlert
            header="Vuoi cancellare la partita?"
            isOpen={showDeleteAlert}
            onDidDismiss={() => setShowDeleteAlert(false)}
            buttons={[
              {
                text: "Annulla",
                role: "cancel",
                handler: async () => {
                  setShowDeleteAlert(false);
                },
              },
              {
                text: "Conferma",
                role: "confirm",
                handler: async () => {
                  // await deleteBooking(parsedBookingId);
                  setShowDeleteAlert(false);
                  await deleteMatch();
                  // // go back to the previous page
                  // history.push("/");
                },
              },
            ]}
          ></IonAlert>
        </div>
        <IonButton
          color="success"
          expand="block"
          size="large"
          onClick={() => updateMatch()}
        >
          Salva
        </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default MatchSettingsPage;
